<div [toggle]="[toggleId, 1]"
     [toggleClass]="'is-open'"
     [toggleClassBy]="[toggleId, 1]"
     [toggleOff]="hideSelector"
     [class.cursor-pointer]="!hideSelector"
     class="w-12 flex p-t-2 p-b-2 flex flex-middle">
    <multisite-flag class="flex m-r-1"
                    [siteId]="current.siteId"></multisite-flag>
    &nbsp;
    <p class="p-l-1-m p-l-1-s"
       [tradeClass]="'!col-11 col-12'"
       sizeClass="'XL': p2, 'MS': h4">{{current.currency}}</p>
    @if (!hideSelector) {
    <i [toggleClass]="'is-up !is-down'"
       [toggleClassBy]="[toggleId, 1]"
       class=" icon-chevron icon-medium inline-flex"
       [tradeClass]="'!col-43 col-42'"></i>
    }
</div>
<div class="hide-up-container pos-absolute bottom-100">
    <div #hideUpEl
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="[toggleId, 1]"
         class="hide-up hide-up-bottom ng-hide ng-hide-animate bg-col-w b-a">
        @for (item of sites; track $index) {
        <a (click)="goTo(item.siteId,$event)"
           class="cursor-pointer flex flex-middle flex-justify-left p-t-2 p-b-2 p-l p-r p2">
            <!-- current.country -->
            <multisite-flag class="flex m-r-1"
                            [siteId]="item.siteId"></multisite-flag>
            {{item.currency}}
        </a>
        }
    </div>
</div>
